var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/arrow-left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.7071068,4.29289322 C13.0976311,4.68341751 13.0976311,5.31658249 12.7071068,5.70710678 L7.415,11 L19,11 C19.5522847,11 20,11.4477153 20,12 C20,12.5522847 19.5522847,13 19,13 L7.415,13 L12.7071068,18.2928932 C13.0675907,18.6533772 13.0953203,19.2206082 12.7902954,19.6128994 L12.7071068,19.7071068 C12.3165825,20.0976311 11.6834175,20.0976311 11.2928932,19.7071068 L4.29289322,12.7071068 L4.21968877,12.625449 C4.2173721,12.6225624 4.21507113,12.6196628 4.21278596,12.6167501 L4.29289322,12.7071068 C4.25749917,12.6717127 4.22531295,12.6343256 4.19633458,12.5953066 C4.17849009,12.5711307 4.1617187,12.546275 4.14606743,12.5206602 C4.13860692,12.5086131 4.13149883,12.4963944 4.12467117,12.4840621 C4.11379392,12.4642939 4.10337664,12.4438914 4.09365378,12.4230991 C4.08567905,12.4060985 4.07819642,12.3887956 4.07122549,12.371336 C4.06331574,12.3515792 4.05612249,12.3317977 4.04954668,12.3117364 C4.04472872,12.2968513 4.04009773,12.2814633 4.03584514,12.265993 C4.02983363,12.2444365 4.0246398,12.2227461 4.02016515,12.2007941 C4.01670217,12.1833753 4.01362808,12.165949 4.0110178,12.1484669 C4.00810098,12.1294204 4.00574796,12.1096949 4.00397748,12.0898018 C4.00189498,12.0659949 4.00063489,12.042681 4.00018615,12.0193545 C4.00006128,12.0129086 4,12.0064615 4,12 L4.00016755,11.9816379 C4.00059932,11.9579802 4.0018656,11.9343349 4.00396641,11.9107499 L4,12 C4,11.9493797 4.00376119,11.8996379 4.01101934,11.8510388 C4.01362808,11.834051 4.01670217,11.8166247 4.02024007,11.7992742 C4.0246398,11.7772539 4.02983363,11.7555635 4.03572097,11.7341604 C4.04009773,11.7185367 4.04472872,11.7031487 4.04973809,11.6878575 C4.05612249,11.6682023 4.06331574,11.6484208 4.07110396,11.6289415 C4.07819642,11.6112044 4.08567905,11.5939015 4.09367336,11.5767785 C4.10337664,11.5561086 4.11379392,11.5357061 4.12487577,11.515723 C4.13149883,11.5036056 4.13860692,11.4913869 4.14599545,11.4792912 C4.1617187,11.453725 4.17849009,11.4288693 4.19631351,11.4048407 C4.20175344,11.397397 4.20728448,11.3901576 4.21292769,11.3829777 C4.23766884,11.3515341 4.26442691,11.3213595 4.29289322,11.2928932 L11.2928932,4.29289322 C11.6834175,3.90236893 12.3165825,3.90236893 12.7071068,4.29289322 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/arrow-left",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/black",
    mask: "url(#mask-2)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.e4bb1bfca56474498ceadb93bf6e2014.svg";
export { ForwardRef as ReactComponent };